import React, { useContext } from 'react';
import styled from 'styled-components/macro';

import { classes } from '@mirinae/react-ui';
import { os } from '@mirinae/js-utils/utils/userAgent';

import PlayerContext from '@mirinae/lessons/modules/contexts/player';
import PageElements from '@mirinae/lessons/components/lesson/PageElements';
import { zIndex } from '@mirinae/lessons/modules/defines/styles';
import { HelpBubble, registerHelp } from '@mirinae/lessons/components/lesson/Help';

const PageTopWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    position: absolute;
    
    .${classes.desktop} & {
        // top: ${props => (props.lowerBtn ? 60 : 40)}px;  computed style due to styled-components issues
        left: 20px;
    }
    .${classes.mobile} & {
        // top: 30px; computed style due to styled-components issues
        left: 15px;
    }
    
    z-index: ${zIndex.float};        
`;

// const LessonsBackButton = styled.div`  // what a hack!!
//     button {
//         padding: 0;
//         border: 0;
//         border-radius: 0;
//         background: transparent;
//         cursor: pointer;
//         font-weight: 500;
//         font-family: ${fontDefault};
//         color: inherit;
//         pointer-events: fill;
    
//         svg {
//             pointer-events: none;
//         }
    
//         &:disabled {
//             cursor: default;
//         }
//     }
// `;

export const PageTop = ({ page }) => {
    const player = useContext(PlayerContext);
    const lowerBtn = player.currentPage.index === 0 && !player.currentSection.notInSectionNav; // drop back button if first page of nav section is showing
    const wrapperPosStyle = () => ({ top: os.isOthers ? (lowerBtn ? 60 : 40) : (lowerBtn ? 60 : 30) });

    return (
        <PageTopWrapper
            className="btn-back" style={wrapperPosStyle()}
            theme={page.background && page.background.toLowerCase() && 'start'}
        >
            {/* <LessonsBackButton>
                <BackButton onClick={player.back}>Back</BackButton>
            </LessonsBackButton> */}
        </PageTopWrapper>
    );
};

// the default renderer for a standard lesson page, includes standard next & back buttons, auto-play stepping, and
//   a call to the standard renderer for all the steps and elements in a page
const DefaultPage = ({ page }) => {

    // map over page elements for current page-build step
    return (
        <>
            <PageTop page={page} />
            <PageElements page={page} />
        </>
    );
};

registerHelp(DefaultPage, [
    <HelpBubble
        title="Click to leave lesson"
        desktop={{ titleAt: 'top', arrowPos: 'right', arrowDir: 'up', style: { top: 85, right:-42, contentWidth: 230 } }}
        mobile={{ titleAt: 'top', arrowPos: 'right', arrowDir: 'right', style: { top: -51, right: 43, contentWidth: 205 } }}>
        <p>Click here to leave the lesson before you have finished it and return to the My Lessons page.</p>
        <p>You can resume the lesson at any time by clicking it&apos;s card the Active Lessons list on the My Lessons page.</p>
    </HelpBubble>,
    <HelpBubble
        title="Skip ahead"
        desktop={{ anchor: '#skip-btn', titleAt: 'bottom', arrowPos: 'right', arrowDir: 'down', style: { bottom: 43, right: 44, contentWidth: 280 } }}>
        <p>When the Skip button is displayed, you can skip past the exercises or explanation animations on this page,
            but you will have to return here and finish to fully comlete the lesson.
        </p>
        <p>When the Next button is enabled, you have completed all necessary exercises and explanation walk-throughs on this page.</p>
    </HelpBubble>,
]);

registerHelp('VocabIntro', [
    <HelpBubble
        title="Click to jump to a section"
        desktop={{ anchor: '.section-bubble', titleAt: 'top', arrowPos: 'left', arrowDir: 'up', style: { top: 37, left: 14, contentWidth: 230 } }}
        mobile={{ anchor: '.section-bubble', titleAt: 'top', arrowPos: 'left', arrowDir: 'up', style: { top: 37, left: 13, contentWidth: 200 } }}>
        <p>Each lesson has one or more sections that you can jump to by clicking on the section&apos;s bar.</p>
    </HelpBubble>,
    <HelpBubble
        title="Green bars show section progress"
        desktop={{ titleAt: 'bottom', arrowPos: 'left', arrowDir: 'down', style: { bottom: 516, left: 13, contentWidth: 230 } }}
        mobile={{ titleAt: 'top', arrowPos: 'left', arrowDir: 'down', style: { top: -37, left: 13, contentWidth: 200 } }}>
        <p>Your progress is tracked in each section and the colored bars show the progress in each.</p>
    </HelpBubble>,
]);

registerHelp('PatternSummary', [
    <HelpBubble
        title="Click to share a link to this page"
        desktop={{ titleAt: 'top', arrowPos: 'left', arrowDir: 'up', style: { top: 57, left: 25, contentWidth: 280 } }}
        mobile={{ titleAt: 'top', arrowPos: 'left', arrowDir: 'up', style: { top: 58, left: 21, contentWidth: 200 } }}>
        <p>Click the link icon to get a link to this page, which you can paste into any message or email for sharing.</p>
    </HelpBubble>,
]);

registerHelp(['PracticePhraseBoard', 'PracticePickOne', 'PracticePhraseSequence', 'PracticeDrag'], [
    <HelpBubble
        title="Skip exercise"
        mobile={{ anchor: '#skip-btn', titleAt: 'bottom', arrowPos: 'left', arrowDir: 'down', style: { bottom: 71, left: -20, contentWidth: 200 } }}>
        <p>When the Skip button is displayed, you can skip past the exercises on this page,
            but you will have to return here and finish it to fully comlete the lesson.
        </p>
        <p>When the Next button is enabled, you have completed all necessary exercises on this page.</p>
    </HelpBubble>,
]);


export default DefaultPage;
